/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import { number, func, string } from 'prop-types';
import classNames from 'clsx';

import p from 'polyglot/polyglot';

import Button from 'components/Button/Button';
import BlackTieIcon from 'components/BlackTieIcon/BlackTieIcon';

import styles from './pagination.scss';

/**
 * This is the Pagination component class.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
const Pagination = ({ next_page, previous_page, onClick, className }) => (
  <nav className={classNames(styles.wrapper, className)}>
    <div className={styles.button}>
      <Button
        disabled={typeof previous_page === 'undefined'}
        onClick={() => onClick(previous_page)}
        small
        dark
        ghost
      >
        {p.t('general.previous')}
      </Button>
    </div>
    <div className={styles.button}>
      <Button
        disabled={typeof next_page === 'undefined'}
        onClick={() => onClick(next_page)}
        small
        dark
        ghost
      >
        {p.t('general.next')}
      </Button>
    </div>
  </nav>
);

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
Pagination.propTypes = {
  next_page: number,
  previous_page: number,
  onClick: func,
  className: string,
};

/**
 * Declare default props.
 *
 * @type {Object}
 */
Pagination.defaultProps = {
  onClick: () => {},
  className: null,
};

export default Pagination;
